import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error untyped dependency
import CoreStorefrontResultsHeader from 'ecosystem-marketplace-core/components/storefront/StorefrontResultsHeader';
import ResultsHeaderDescription from './ResultsHeaderDescription';
import ResultsHeaderTitle from './ResultsHeaderTitle';

function ResultsHeader(_ref) {
  let {
    description,
    routeParams,
    searchTerm,
    title
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["description", "routeParams", "searchTerm", "title"]);

  return /*#__PURE__*/_jsx(CoreStorefrontResultsHeader, Object.assign({}, rest, {
    description: /*#__PURE__*/_jsx(ResultsHeaderDescription, {
      description: description,
      routeParams: routeParams,
      searchTerm: searchTerm
    }),
    searchTerm: searchTerm,
    title: /*#__PURE__*/_jsx(ResultsHeaderTitle, {
      routeParams: routeParams,
      searchTerm: searchTerm,
      title: title
    })
  }));
}

export default ResultsHeader;